import React, {useEffect, useRef, memo, useContext} from 'react';
import moment from 'moment';
import { useQueryClient } from 'react-query';
import {fetch as fetchHasChanges} from '../../services/flightPlanning/useHasChanges';
import {fetch as fetchFlightChanges} from '../../services/flights/useHasChanges';
import SystemContext from '../../SystemContext';
import { useIdleTimer } from 'react-idle-timer';

const RefreshCheck = (props) => {
  const SystemData = useContext(SystemContext);
  const eventBus = SystemData.eventBus;
  const queryClient = useQueryClient();
  const refreshRef = useRef({lastCheck: moment().toISOString()});

  const timerRef = useRef(null);
  const pauseRef = useRef('');

  const handleOnIdle = () => {
    function refreshCheck() {
      const lastCheck = refreshRef.current.lastCheck;
      if (pauseRef.current) {
        console.debug('refresh paused', pauseRef.current);
      } else {
        refreshRef.current.lastCheck = moment().toISOString();
        switch (props.checkType) {
          case "Flight Planning":
            const extraKeys = [props.periodFrom, props.periodTo, lastCheck];
            fetchHasChanges({
              queryClient, extraKeys, callback: (data) => {
                if (data) {
                  eventBus.trigger(props.refreshEventName);
                }
              }
            });
            break;
          case "Flight List":
            fetchHasChanges({
              queryClient, extraKeys: [props.year, props.month, lastCheck], callback: (data) => {
                if (data) {
                  eventBus.trigger(props.refreshEventName);
                }
              }
            });
            break;
          default:
            eventBus.trigger(props.refreshEventName);
            break;
        }
      }
    }
    if (!timerRef.current) {
      console.log('Initial Refreshing');
      refreshCheck();
      timerRef.current = setInterval(()=> {
        console.log('Refreshing');
        refreshCheck();
      }, (props.refreshSeconds||30) * 1000);
    } else {
      console.log('RefreshCheck timer already set')
    }
  }

  const handleOnActive = () => {
    console.log('onActive');
    if (timerRef.current) {
      console.log('cancelled Refresh Timer');
      clearInterval(timerRef.current);
      timerRef.current = null;
    }
  }

  const handlePause = (paused, i) => {
    if (i) {
      if (paused) {
        if (`${pauseRef.current}`.indexOf(`${i}`) < 0) {
          pauseRef.current += `${i}`;
        }
      } else {
        pauseRef.current = `${pauseRef.current}`.trim().replace(`${i}`,'');
      }
    } else {
      pauseRef.current = paused;
    }
  }

  const {reset} = useIdleTimer({
    timeout: 1000 * (props.idleSeconds||30),
    onIdle: handleOnIdle,
    onActive: handleOnActive,
    debounce: 500
  })


  useEffect(()=> {
    reset();
    if (props.pauseEventName) {
      if (Array.isArray(props.pauseEventName)) {
        props.pauseEventName.forEach((eventName, i) => {
          eventBus.bind(eventName, (paused) => handlePause(paused, i+1));
        });
      } else {
        eventBus.bind(props.pauseEventName, handlePause);
      }

    }
    return () => {
      console.log('unloading RefreshCheck');
      if (props.pauseEventName) {
        if (Array.isArray(props.pauseEventName)) {
          props.pauseEventName.forEach((eventName, i) => {
            eventBus.unbind(eventName, (paused) => handlePause(paused, i+1));
          });
        } else {
          eventBus.unbind(props.pauseEventName, handlePause);
        }
      }
      if (timerRef.current) {
        clearInterval(timerRef.current);
        timerRef.current = null;
      }
    }
  },[eventBus, props.pauseEventName, props.periodFrom, props.periodTo, props.refreshEventName, queryClient])

  return (<>{props.children}</>);
}

export default memo(RefreshCheck);